
(function(){
  'use strict';

  /* ── CSS ── */
  const css = `
    .qv-btn {
      position: absolute; bottom: 12px; left: 50%; transform: translateX(-50%);
      background: #1a1a2e; color: #fff; border: none; border-radius: 6px;
      padding: 8px 18px; font-size: 13px; font-weight: 600; cursor: pointer;
      white-space: nowrap; opacity: 0; transition: opacity 0.2s ease;
      z-index: 10; pointer-events: none;
    }
    .card-media:hover .qv-btn, .card-media:focus-within .qv-btn { opacity: 1; pointer-events: auto; }
    .qv-overlay {
      display: none; position: fixed; inset: 0; background: rgba(0,0,0,0.6);
      z-index: 10000; align-items: center; justify-content: center; padding: 16px;
    }
    .qv-overlay.open { display: flex; }
    .qv-modal {
      background: #fff; border-radius: 12px; max-width: 860px; width: 100%;
      max-height: 90vh; overflow-y: auto; position: relative;
      display: grid; grid-template-columns: 1fr 1fr; gap: 0;
      box-shadow: 0 20px 60px rgba(0,0,0,0.3);
    }
    @media(max-width:640px){ .qv-modal { grid-template-columns: 1fr; } }
    .qv-close {
      position: absolute; top: 12px; right: 14px; background: none; border: none;
      font-size: 24px; cursor: pointer; color: #666; line-height:1; z-index:2;
    }
    .qv-img-wrap { background: #f5f5f5; border-radius: 12px 0 0 12px; overflow: hidden; min-height: 320px; display:flex; align-items:center; justify-content:center; }
    @media(max-width:640px){ .qv-img-wrap { border-radius: 12px 12px 0 0; min-height:220px; } }
    .qv-img-wrap img { width: 100%; height: 100%; object-fit: contain; max-height: 420px; }
    .qv-info { padding: 32px 28px; display: flex; flex-direction: column; gap: 12px; }
    .qv-vendor { font-size: 12px; text-transform: uppercase; letter-spacing: 1px; color: #888; margin:0; }
    .qv-title { font-size: 18px; font-weight: 700; color: #1a1a2e; margin:0; line-height:1.3; }
    .qv-price { font-size: 22px; font-weight: 700; color: #1a1a2e; }
    .qv-price s { color: #999; font-size: 16px; font-weight:400; margin-right: 8px; }
    .qv-options { display: flex; flex-direction: column; gap: 10px; }
    .qv-option label { display:block; font-size:12px; font-weight:600; color:#555; margin-bottom:4px; }
    .qv-option select {
      width: 100%; padding: 9px 12px; border: 1.5px solid #ddd; border-radius: 6px;
      font-size: 14px; cursor: pointer; background:#fff;
    }
    .qv-atc {
      background: #e8a838; color: #1a1a2e; border: none; border-radius: 8px;
      padding: 13px 24px; font-size: 15px; font-weight: 700; cursor: pointer;
      transition: background 0.2s; margin-top: 4px;
    }
    .qv-atc:hover { background: #d4962e; }
    .qv-atc:disabled { background: #ccc; cursor: not-allowed; }
    .qv-full { display:block; text-align:center; font-size:13px; color:#1a1a2e; text-decoration:underline; margin-top:4px; }
    .qv-loading { text-align:center; padding: 60px; grid-column: 1/-1; color:#666; }
    .qv-added { background: #2d8a4e !important; color:#fff !important; }
  `;
  const s = document.createElement('style'); s.textContent = css; document.head.appendChild(s);

  /* ── Modal HTML ── */
  const modal = document.createElement('div');
  modal.id = 'qv-overlay'; modal.className = 'qv-overlay'; modal.setAttribute('role','dialog'); modal.setAttribute('aria-modal','true');
  modal.innerHTML = '<div class="qv-modal" id="qv-modal"><button class="qv-close" id="qv-close" aria-label="Close">&times;</button></div>';
  document.body.appendChild(modal);

  /* ── Helpers ── */
  const fmt = p => '\u00a3' + (p/100).toFixed(2);
  const el = id => document.getElementById(id);

  function close() {
    el('qv-overlay').classList.remove('open');
    document.body.style.overflow = '';
  }
  el('qv-close').addEventListener('click', close);
  el('qv-overlay').addEventListener('click', e => { if(e.target === el('qv-overlay')) close(); });
  document.addEventListener('keydown', e => { if(e.key==='Escape') close(); });

  /* ── Open ── */
  document.addEventListener('click', async e => {
    const btn = e.target.closest('.qv-btn');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    const handle = btn.dataset.handle;
    const url = btn.dataset.url;

    // Show overlay with loader
    const modal = el('qv-modal');
    modal.innerHTML = '<button class="qv-close" id="qv-close" aria-label="Close">&times;</button><div class="qv-loading">Loading...</div>';
    el('qv-overlay').classList.add('open');
    document.body.style.overflow = 'hidden';
    el('qv-close').addEventListener('click', close);

    try {
      const resp = await fetch('/products/' + handle + '.js');
      const product = await resp.json();
      render(modal, product, url);
    } catch(err) {
      modal.innerHTML = '<button class="qv-close" id="qv-close">&times;</button><div class="qv-loading">Failed to load product.</div>';
      el('qv-close').addEventListener('click', close);
    }
  });

  /* ── Render ── */
  function render(modal, p, url) {
    const v = p.variants[0];
    const hasOptions = !(p.variants.length === 1 && p.variants[0].title === 'Default Title');

    let optionsHTML = '';
    if (hasOptions) {
      optionsHTML = '<div class="qv-options">' + p.options.map((opt, oi) => { const optName = typeof opt === 'string' ? opt : opt.name;
        const vals = [...new Set(p.variants.map(v => v['option'+(oi+1)]))];
        return '<div class="qv-option"><label>' + optName + '</label><select data-option-index="' + oi + '">' +
          vals.map(val => '<option value="' + val + '">' + val + '</option>').join('') +
          '</select></div>';
      }).join('') + '</div>';
    }

    const priceHTML = v.compare_at_price > v.price
      ? '<s>' + fmt(v.compare_at_price) + '</s>' + fmt(v.price)
      : fmt(v.price);

    modal.innerHTML = `
      <button class="qv-close" id="qv-close" aria-label="Close">&times;</button>
      <div class="qv-img-wrap">
        <img id="qv-img" src="${p.featured_image}" alt="${p.title}">
      </div>
      <div class="qv-info">
        <p class="qv-vendor">${p.vendor}</p>
        <h2 class="qv-title">${p.title}</h2>
        <div class="qv-price" id="qv-price">${priceHTML}</div>
        ${optionsHTML}
        <button class="qv-atc" id="qv-atc" data-vid="${v.id}">${v.available ? 'Add to Cart' : 'Sold Out'}</button>
        <a class="qv-full" href="${url}">View full product &rarr;</a>
      </div>
    `;

    el('qv-close').addEventListener('click', close);

    // Variant selection
    if (hasOptions) {
      modal.querySelectorAll('select[data-option-index]').forEach(sel => {
        sel.addEventListener('change', () => {
          const selected = Array.from(modal.querySelectorAll('select')).map(s=>s.value);
          const match = p.variants.find(v => selected.every((val,i) => v['option'+(i+1)] === val));
          if (match) {
            const priceH = match.compare_at_price > match.price
              ? '<s>'+fmt(match.compare_at_price)+'</s>'+fmt(match.price)
              : fmt(match.price);
            el('qv-price').innerHTML = priceH;
            el('qv-atc').dataset.vid = match.id;
            el('qv-atc').textContent = match.available ? 'Add to Cart' : 'Sold Out';
            el('qv-atc').disabled = !match.available;
            if(match.featured_image) el('qv-img').src = match.featured_image.src;
          }
        });
      });
    }

    // Add to cart
    el('qv-atc').addEventListener('click', async function() {
      const vid = parseInt(this.dataset.vid);
      this.textContent = 'Adding...';
      this.disabled = true;
      try {
        const r = await fetch('/cart/add.js', {
          method:'POST', headers:{'Content-Type':'application/json'},
          body: JSON.stringify({id: vid, quantity: 1})
        });
        if (r.ok) {
          this.textContent = '\u2713 Added!';
          this.classList.add('qv-added');
          // Update cart count if element exists
          const cartCount = document.querySelector('.cart-count, [class*="cart-count"], .header-cart-count');
          if(cartCount) {
            const c = await fetch('/cart.js').then(r=>r.json());
            cartCount.textContent = c.item_count;
          }
          setTimeout(() => { this.textContent = 'Add to Cart'; this.disabled = false; this.classList.remove('qv-added'); }, 2000);
        } else {
          this.textContent = 'Error — try again';
          this.disabled = false;
        }
      } catch(e) {
        this.textContent = 'Error — try again';
        this.disabled = false;
      }
    });
  }
})();
